import { render, staticRenderFns } from "./preventionbrigadePagination.vue?vue&type=template&id=1e881fc5&"
import script from "./preventionbrigadePagination.vue?vue&type=script&lang=js&"
export * from "./preventionbrigadePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports